import {
  ApiBlobGetRequest,
  ApiGetRequest,
  ApiPostRequest,
  ApiPutRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Penjualan Depo Tunai',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Penjulan Depo Tunai',
        href: '/adm/fin/penjualan/depo-tunai',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_inv_depo_cash',
    sortDesc: true,
    fields_account: [
      {
        key: 'code_acc',
        label: 'Kode Akun',
        sortable: true,
      },
      {
        key: 'classification',
        label: 'Klasifikasi',
        sortable: true,
      },
      {
        key: 'acc_name',
        label: 'Nama Akun',
        sortable: true,
      },
      {
        key: 'acc_alias',
        label: 'Alias',
        sortable: true,
      },
      {
        key: 'currency',
        label: 'Mata Uang',
        sortable: true,
      },
      {
        key: 'is_active',
        label: 'Aktif',
        sortable: true,
      },
    ],
    fields: [
      {
        key: 'code_inv_depo',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'date_inv',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'date_trans',
        label: 'Transaksi',
        sortable: true,
      },
      {
        key: 'department',
        label: 'Department',
        sortable: true,
      },
      {
        key: 'total_hpp',
        label: 'Total',
      },
      {
        key: 'total_ppn10',
        label: 'PPN',
      },
      {
        key: 'total_invoice',
        label: 'Total Final',
      },
      {
        key: 'status_inv',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    form: {
      code_inv_depo: '',
      date_inv: '',
      id_department: '',
      id_currency: '',
      remark: '',
      total_cost: '',
      acc_other_cost: '',
      other_cost: '',
      acc_disc_final: '',
      disc_final: '',
      total_hpp: '',
      total_ppn10: '',
      total_pph23: '',
      total_invoice: '',
      acc_payment: '',
      total_payment: '',
      id_journal: '',
      term_payment: '',
      status_inv: '',
      details: [],
    },
    journal: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  journal(state) {
    return state.data.journal;
  },
};

export const mutations = {
  changeDepoCash(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getJournalDepoCash({ commit }, payload = null) {
    commit('changeDepoCash', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `fin/depo-cash/${payload.id_inv_depo_cash}/journal`
    );
    commit('changeDepoCash', {
      loading: false,
      journal: result.error ? [] : result.data.object,
    });

    return result.error ? false : true;
  },

  async getListInvDepoCash({ commit, state }, payload = null) {
    commit('changeDepoCash', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      status: payload.status ? payload.status : '',
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
      ...payload,
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`fin/depo-cash`, params);
      commit('changeDepoCash', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_invoice_cash.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`fin/depo-cash`, params);
      commit('changeDepoCash', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getCostCash({ commit, state }, payload = null) {
    commit('changeDepoCash', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('fin/depo-cash/get-price', {
      start_date:
        data.form.date_trans && data.form.date_trans[0]
          ? moment(data.form.date_trans[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        data.form.date_trans && data.form.date_trans[1]
          ? moment(data.form.date_trans[1]).format('YYYY-MM-DD')
          : '',
      payment_type: payload.payment_type,
      id_currency: data.form.id_currency || '',
    });

    commit('changeDepoCash', {
      loading: false,
    });

    if (!result.error && result.data.object) {
      return result.data.object || {};
    }

    return false;
  },

  async getDetailCostCash({ commit, state }, payload = null) {
    commit('changeDepoCash', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/depo-cash/${payload.id}`);
    commit('changeDepoCash', {
      loading: false,
    });

    if (!result.error) {
      commit('changeDepoCash', {
        form: {
          ...data.form,
          ...result.data.object,
          date_trans: [
            result.data.object && result.data.object.date_start
              ? result.data.object.date_start
              : '',
            result.data.object && result.data.object.date_end
              ? result.data.object.date_end
              : '',
          ],
        },
      });

      return true;
    }

    return false;
  },

  async createCostCash({ commit, state, dispatch }) {
    commit('changeDepoCash', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('fin/depo-cash', data.form);

    commit('changeDepoCash', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateCostCash({ commit, state, dispatch }, payload = null) {
    commit('changeDepoCash', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(`fin/depo-cash/${payload.id}`, data.form);

    commit('changeDepoCash', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async getDetailSetupAccount({ commit }, payload = null) {
    commit('changeDepoCash', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/depo-cash/${payload.id}`);
    commit('changeDepoCash', {
      loading: false,
    });

    if (!result.error) {
      commit('changeDepoCash', {
        detail: result.data.object,
      });
    }

    return !result.error ? true : false;
  },
};
